import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../../components/buttons/customButton';
import { useClearFormSubmissionIndex } from '../../../apiHooks/mutations/internalSync/useClearFormSubmissionIndex';
import { useClearAdsIndex } from '../../../apiHooks/mutations/internalSync/useClearAdsIndex';
import {
  InternalDateRangePickerBar,
  useInternalDateRange,
} from '../internalDateRangePickerBar';

interface DeleteItem {
  titleKey: string;
  endpoint: string;
  onDelete: () => void;
  isLoading: boolean;
}

const DeleteTabPanel = () => {
  const { t } = useTranslation();
  const {
    filterRange,
    setFilterRange,
    isCalendarOpen,
    setIsCalendarOpen,
    dateRangeParams,
    isDateRangeValid,
  } = useInternalDateRange();

  const { mutate: clearFormSubmissionIndex, isLoading: isClearingFormSubmissions } = useClearFormSubmissionIndex();
  const { mutate: clearAdsIndex, isLoading: isClearingAds } = useClearAdsIndex();

  const deleteItems: DeleteItem[] = [
    {
      titleKey: 'clearFormSubmissionIndex',
      endpoint: 'digger-core-api/form-submission/index/clear',
      onDelete: () => clearFormSubmissionIndex(dateRangeParams),
      isLoading: isClearingFormSubmissions,
    },
    {
      titleKey: 'clearAdsIndex',
      endpoint: 'digger-core-api/ads/index/clear',
      onDelete: () => clearAdsIndex(dateRangeParams),
      isLoading: isClearingAds,
    },
  ];

  return (
    <div>
      <InternalDateRangePickerBar
        dataCy="internal-delete-date-toggle"
        filterRange={filterRange}
        setFilterRange={setFilterRange}
        isCalendarOpen={isCalendarOpen}
        setIsCalendarOpen={setIsCalendarOpen}
      />
      <div className="flex flex-col gap-4">
        {deleteItems.map((item) => (
          <div
            key={item.titleKey}
            className="flex items-center justify-between gap-5 rounded-xl border p-4"
          >
            <div className="flex flex-col gap-1">
              <p className="text-sm font-[500] text-primary">{t(item.titleKey)}</p>
              <p className="text-xs text-gray-3">{item.endpoint}</p>
            </div>
            <CustomButton
              disabled={item.isLoading || !isDateRangeValid}
              className="h-[40px] px-[20px] text-sm"
              onClick={item.onDelete}
            >
              {t('delete')}
            </CustomButton>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeleteTabPanel;
